import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getPublicSearchTotalKey } from '~/constants/react-query-keys';
import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';
import { type SearchTotals } from '~/types/SearchTotals';

/**
 * The legacy path sets the collection-wide search total from PublicShowcaseGalleryView, which
 * is unmounted in blocks mode. Set it here from the full, unmasked items data — the listing
 * blocks each render a masked per-category slice and must not write masked totals.
 */
export const usePublicShowcaseBlocksSearchTotal = ({ shortId }: { shortId: string }) => {
  const queryClient = useQueryClient();
  const { useGalleryViewItems } = usePublicShowcaseContext();
  const itemsData = useGalleryViewItems({ shortId });

  useEffect(() => {
    queryClient.setQueryData<SearchTotals>(getPublicSearchTotalKey(shortId), {
      total: itemsData.data.boards.total + itemsData.data.clips.total + itemsData.data.files.total,
    });
  }, [itemsData, queryClient, shortId]);
};
